import { render, staticRenderFns } from "./creatSecond.vue?vue&type=template&id=6c800a56&scoped=true"
import script from "./creatSecond.vue?vue&type=script&lang=ts"
export * from "./creatSecond.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c800a56",
  null
  
)

export default component.exports